import { render, staticRenderFns } from "./ResultTable.vue?vue&type=template&id=4830721e&scoped=true&"
import script from "./ResultTable.vue?vue&type=script&lang=js&"
export * from "./ResultTable.vue?vue&type=script&lang=js&"
import style0 from "./ResultTable.vue?vue&type=style&index=0&id=4830721e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4830721e",
  null
  
)

export default component.exports